import { type FC } from 'react';
import { Help, type HelpProps, Link, Text } from '@direct-frontend/components';
import { NON_BREAKING_SPACE } from '#shared/lib/constants';
import { settingsFeedbackRoute } from '#shared/lib/routes';

/**
 * Подсказка для заголовка колонки с рейтингом и отзывами.
 *
 * @kind component
 */
export const ProductFeedbacksHelp: FC<HelpProps> = (props) => (
    <Help maxWidth="360" {...props}>
        <Text size="s">
            Добавьте рейтинг и отзывы в разделе{' '}
            <Link href={settingsFeedbackRoute.getUrl()}>
                {`Настройки${NON_BREAKING_SPACE}→${NON_BREAKING_SPACE}Отзывы`}
            </Link>
            .
        </Text>
    </Help>
);
